import { TranslocoService } from '@ngneat/transloco';
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { LogentryModel } from 'projects/core/src/lib/models/logentry.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { SentmessageModel } from 'projects/core/src/lib/models/sentmessage.model';
import { CANDIDATES_RIGHTS } from 'projects/admin/src/app/shared/constants';

@Component({
  selector: 'app-order-detail-log',
  templateUrl: './order-detail-log.component.html',
  styleUrls: ['./order-detail-log.component.scss']
})
export class OrderDetailLogComponent implements OnInit, OnChanges {

  @Input() order: AcModel | null = null;

  public logs: Array<any> = [];
  public messageVisible = false;
  public messageSelected: SentmessageModel = null;

  constructor(
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.order?.logs) {
      this.logs = this.order.logs.map((entry: LogentryModel) => {
        return {
          timestamp: entry.timestamp,
          change: entry.change,
          value: this.getValue(entry),
          user: entry.user,
          message: entry.message,
        };
      });
    }
  }

  private getValue(entry: LogentryModel): string | null {
    if (entry.change === 'mail') {
      return entry.value;
    } else if (entry.change === 'status' && entry.value?.status?.new) {
      return this.transloco.translate('ac_log.new_status', { value: this.transloco.translate('common.labels.' + entry.value?.status.new) });
    } else if (this.auth.isSuperUser()) {
      // return JSON.stringify(entry.value);
    }
    return null;
  }

  public onShowMailContent(sentmessage: SentmessageModel): void {
    this.messageVisible = true;
    this.messageSelected = sentmessage;
  }

  public canSeeCandidates(): boolean {
    return this.auth.hasOneRight(CANDIDATES_RIGHTS);
  }

}
